import React, { useState } from "react";

const marketingOptions = [
  "I / We wish to be included in the marketing communication by or on behalf of Ad-Luck Holdings Parners",
  "I / We wish to be included in the marketing or customers list sold or distributed by Ad-Luck Partners",
  "Would you like a consultant from Ad-Lucks or Ad-Luck Partners to contact you regarding other products offered?",
];

const invitationOptions = [
  "I / We the undersigned hereby select the following payment options for initiation fees in accordance with the national credit act (Act 34 of 2005) due to the application for finance with Ad-Luck partners.",
  "The initiation fees will be paid on approval and acceptance of funding",
  "The Initiation fees must be included in the principal debt for repayment over the period of the credit agreement. (Amount to be debited on the signature date of the funding agreement.)",
];

const Section5 = () => {
  const [selectedMarketing, setSelectedMarketing] = useState([]);
  const [selectedInvitation, setSelectedInvitation] = useState([]);

  const toggleSelection = (item, selectedList, setSelectedList) => {
    setSelectedList((prevSelected) =>
      prevSelected.includes(item)
        ? prevSelected.filter((val) => val !== item)
        : [...prevSelected, item]
    );
  };

  const renderSection = (title, options, selectedList, setSelectedList) => (
    <>
      <h2 className="text-[10px] sm:text-[8px] md:text-[24px] font-bold mt-6 md:mt-12 text-[#979797]">
        {title.split(":")[0]}:{" "}
        <span className="text-[#03897B]">{title.split(":")[1].trim()}</span>
      </h2>
  
      <div className="grid grid-cols-1 md:gap-4 gap-2 mt-1 md:mt-2">
        {options.map((option, i) => { 
          const isActive = selectedList.includes(option);
          return (
            <div
              key={i}
              className="flex items-center gap-2 cursor-pointer"
              onClick={() =>
                toggleSelection(option, selectedList, setSelectedList)
              }
            >
              {/* Rectangle */}
              <div
                className={`
                  flex-1 text-left
                  md:h-[81px] h-[28px] // Height adjustment for mobile
                  bg-[#E7EBEB]
                  border border-[#E7EBEB] rounded-[5px]
                  px-4 flex items-center
                `}
              >
                <span className="font-normal leading-tight text-[6px] sm:text-[8px] md:text-[20px]">
                  {option}
                </span>
              </div>
  
              {/* Circle box */}
              <div className="flex items-center justify-between px-4 md:px-10 rounded-[5px] md:w-[300px] md:h-[78px] w-[120px] h-[28px] bg-[#D9D9D9]">
                <p className="text-center text-[8px]  md:text-[20px] w-full font-medium">
                  Yes
                </p>
                <div
                  className={`
                    md:w-[64px] md:h-[64px] w-3 h-3 rounded-full shrink-0
                    ${isActive
                      ? "bg-[#03897B] md:border-[9px] border-[3px] border-white"
                      : "bg-transparent md:border-[9px] border-[3px] border-white"}
                    sm:w-3 sm:h-3
                  `}
                />
              </div>
            </div>
          );
        })}
      </div>
    </>
  );

  return (
    <div>
      {renderSection(
        "Section 5 : MARKETING",
        marketingOptions,
        selectedMarketing,
        setSelectedMarketing
      )}

      {renderSection(
        "Section 6 : INVITATION FEES",
        invitationOptions,
        selectedInvitation,
        setSelectedInvitation
      )}
    </div>
  );
};

export default Section5;
